import * as React from 'react';
export const SvgFiletypeRevit = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M11 3V0H2v16h12V3z', fill: '#005a92' }),
        React.createElement("path", { d: 'M7.6 9.4l2.72 3.12 1.68-.08-3.2-3.68c1.297-.344.96-2.16.96-2.16a3.062 3.062 0 00-2.8-2.56L4 4.12 6.48 13l1.6-.16-1.04-3.68a.744.744 0 01.56.24zm-.96-1.52L6 5.56a3.183 3.183 0 01.88-.08 1.424 1.424 0 011.44 1.28.765.765 0 01-.64 1.04z', fill: '#fff', fillRule: 'evenodd' }),
        React.createElement("path", { d: 'M11 0l3 3h-3z', fill: '#003f66' })));
};
export default SvgFiletypeRevit;
